import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../common/components/TextInput';

/**
 * New Ticket Email field component
 * Specifically for offline ticket submission
 */
const Email = ({ name, onChange, value, error }) => (
  <TextInput
    name={name}
    label="Authorized Email Address"
    onChange={onChange}
    classes="animated fadeIn"
    value={value}
    error={error}
  />
);

Email.propTypes = {
  /** The form name and schema key */
  name: PropTypes.string.isRequired,
  /** Callback for change event */
  onChange: PropTypes.func.isRequired,
  /** The current field value */
  value: PropTypes.string.isRequired,
  /** The possible error of the field */
  error: PropTypes.string
};

export default Email;
